const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  popupClose: 'close-popup',
  facetsUpdate: 'facets-update',
  quickBuyChange: 'quick-buy-change',
  notifyMe: 'notify-me',
  wishlistChange: 'wishlist-change',
  onBikiniConfiguratorChange: 'on-bikini-change',
  onBikiniConfiguratorUpdate: 'on-bikini-update',
  onProvinceUpdate: 'on-province-update',
  countryPopupOpen: 'country-popup-open',
  onGenericTrackEvent: 'on-generic-track-event',
  onCloseDrawerEvent: 'on-close-drawer-event'
};
